import { ReactSVG } from "react-svg"

const formatCurrency = (amount) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
    }).format(amount);
  };

const columns = [
    {
        name: "Product Code",
        selector: (row) => row.product_code,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Category",
        selector: (row) => row.category ? row.category.name : '-',
        sortable: true,
        maxWidth: "200px",
    },
    {
        // Ini nanti ganti sama gambarnya product, bukan gambar fabric
        name: "Product Name",
        selector: (row) => row.product_name,
        sortable: true,
        format: (row) => {
            const fallback = 'https://dummyimage.com/600x400/000/fff&text=Laxmi+Tailors'
            const thumbnailUrl = (() => {
                if (!row || !row.fabric || !row.fabric.image) return fallback
                return row.fabric.image.thumbnail_url || fallback
            })()
            return (
                <div className="d-flex flex-row" style={{ alignItems: "center" }}>
                    <img src={thumbnailUrl} alt={row.product_name || 'Thumbnail'} style={{ height: "120px", width: "150px", borderRadius: "32px", marginRight: "16px", objectFit: 'cover' }} />
                    <div>{row.product_name}</div>
                </div>
            )
        }
    },
    {
        name: "Price",
        selector: (row) => formatCurrency(row.price),
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Description",
        selector: (row) => row.description,
        sortable: true,
        maxWidth: "200px",
    },
    {
        name: "Status",
        selector: (row) => row.status,
        sortable: true,
        maxWidth: "200px",
        format: (row) => {
            return (
                <div style={{
                    padding: "4px 8px",
                    borderRadius: "4px",
                    color: row.status === "aktif" ? '#1EB200' : 'white',
                    backgroundColor: row.status === "aktif" ? '#D5FFCC' : 'red'
                }}>{row.status === "aktif" ? 'Active' : 'Non-Active'}</div>
            )
        }
    },
]

export default columns